import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Alert, Button, Col, Form, Row } from 'reactstrap';
import { FaUserEdit, FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { GoKey } from 'react-icons/go';
import InputField from '../InputField';
import { loginNew } from 'layouts/Landing/newAuthService';
import { setToken, setEmail } from 'utils/storageUtil';
import './Login.scss';
import SLButton from 'atoms/SLButton/SLButton';
import { useDispatch, useSelector } from 'react-redux';
import { getOktaURL } from 'store/Auth/auth.action';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { emailRex, EMPTY_STRING, GROUPM_EMAIL_DOMAIN, GROUPM_ERROR_MESSAGE } from 'commons/constants';
import { verifyEmail } from '../utils';

const Login = (props) => {
  const { register, handleSubmit, errors, watch, setValue } = useForm({ mode: 'onBlur' });
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [visiblePassword, setVisiblePassword] = useState(false);
  const togglePassword = () => setVisiblePassword((prev) => !prev);
  const dispatch = useDispatch();
  const watchEmail = watch('email', '');
  const watchPassword = watch('password', '');

  const AuthLogin = useSelector((state) => state.AuthLogin);

  const _getOktaURL = () => {
    dispatch(getOktaURL({}));
  };
  useEffect(() => {
    if (AuthLogin.oktaURL.loader.fulfilled) {
      openInNewTab(AuthLogin.oktaURL.data.id);
    }
  }, [AuthLogin.oktaURL.loader.fulfilled]);

  useEffect(()=>{
   setErrorMessage(EMPTY_STRING)
  },[watchPassword,watchEmail])

  useEffect(() => {
    if (location.hash.includes('okta')) {
      const params = location.hash
        .split('#')[1]
        .split('&')
        .reduce((acc, item) => {
          const [key, value] = item.split('=');
          acc[key === 'code' ? 'authcode' : key] = value;
          return acc;
        }, {});
      onSubmit({}, params);
    }
  }, [location.hash]);

  useEffect(()=>{
    if(location.search.includes("okta.com")){
      _getOktaURL()
    }
  },[location.search])

  useEffect(() => {
    if (verifyEmail(watchEmail) && watchEmail && watchEmail.toLowerCase().includes("@")) {
      const emailDomain = watchEmail.toLowerCase().split('@')[1];
      const isGroupMEmail = emailDomain === GROUPM_EMAIL_DOMAIN;
      if (isGroupMEmail) {
        setErrorMessage(GROUPM_ERROR_MESSAGE);
        setIsShowPassword(false);
      } else {
        setErrorMessage('');
        setIsShowPassword(true);
      }
    } else {
      setIsShowPassword(false);
    }
  }, [watchEmail]);

  const openInNewTab = (url) => {
    window.location.href = url;
  };

  const onSubmit = (values, params = {}) => {
    loginNew(values, params).then((res) => {
      if (res && res.data?.status) {
        const { name, email } = res.data.id;
        setToken(res.headers.authorization);
        setEmail(email);
        setErrorMessage('');
        props.history.push('/dashboard');
        window.Intercom('update', { name: name, email: email });
        // window.lifesight.identify({userId: email, email, attributes: { name }});
      } else {
        setErrorMessage(
          (res && res?.data?.message) || 'Please try again later'
        );
      }
    });
  };

  const openSupportChat = () => {
    window.Intercom('show');
  };

  const passwordSuffix = visiblePassword ? (
    <FaRegEyeSlash
      size={16}
      className="cursor-pointer"
      onClick={togglePassword}
    />
  ) : (
    <FaRegEye size={16} className="cursor-pointer" onClick={togglePassword} />
  );

  const toggele = () => {
    setErrorMessage(EMPTY_STRING)
    setValue('email', EMPTY_STRING)
  }

  return (
    <div>
      {errorMessage && (
        <Alert
          color="danger"
          className="mx-4 px-2"
          toggle={toggele}
          style={{
            transition: 'all 0.3s ease-in-out'
          }}
        >
          {errorMessage}
        </Alert>
      )}

      <Form onSubmit={handleSubmit((values)=>onSubmit(values))} className="mx-4 px-2">
        <InputField
          type="email"
          placeholder="Email"
          name="email"
          prefix={<FaUserEdit size={16} />}
          error={errors.email}
          ref={register({
            required: 'Email is required',
            pattern: {
              value: emailRex,
              message: 'Invalid Email address',
            },
          })}
        />

        {isShowPassword && (
          <InputField
            type={  visiblePassword ? 'text' : 'password'}
            placeholder="Password"
            name="password"
            prefix={<GoKey size={16} />}
            suffix={passwordSuffix}
            error={errors.password}
            ref={register({
              required: 'Password is required',
            })}
           
          />
        )}

        <SLButton type="submit" disabled={errorMessage.length>0} block className="mb-3 login-btn">
          Login
        </SLButton>
      </Form>

      <div className="clearfix mx-4 px-2">
        <Link to="#" className="float-left link" onClick={openSupportChat}>
          Support
        </Link>
        <Link to="/auth/forgot-password" className="float-right link">
          Forgot Password?
        </Link>
      </div>
      <Row className="justify-content-center okta_logo">
        <Col
          md={7}
          data-toggle="okta-tooltip"
          data-placement="right"
          title="Click to login via OKTA"
          onClick={_getOktaURL}
        >
          <Button outline={false} color="primary" id='okta_login'  style={{width: "100%", background:'#1e0a44'}} >Login With OKTA</Button>
        </Col>
      </Row>

      <div className="mt-5 text-center">
        Don&apos;t have any account?{' '}
        <Link to="#" onClick={openSupportChat} className="link">
          Request for an account.
        </Link>
      </div>
    </div>
  );
};

export default Login;
